import gentianLogo from '../../Assets/GentianLogo_2024.png';
import { useMediaQuery, useTheme } from '@mui/material';

export const LogoComponent = ({ hasOnlyIcon }: { hasOnlyIcon?: boolean }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (hasOnlyIcon) {
    return (
      <img
        src={gentianLogo}
        alt="Gentian logo"
        style={{
          height: isMobile ? '64px' : '128px',
          width: isMobile ? '64px' : '128px',
          minWidth: isMobile ? '64px' : '128px',
          objectFit: 'cover',
          objectPosition: 'left',
        }}
        loading="lazy"
      />
    );
  }

  return (
    <img
      src={gentianLogo}
      alt="Gentian logo"
      style={{
        height: '45px',
        width: '100%',
        minWidth: '100px',
        objectFit: 'contain',
      }}
      loading="lazy"
    />
  );
};
